import React from 'react';

export const Footer: React.FC = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm text-slate-600">
            {[
                {
                    step: 1,
                    title: 'Upload Files',
                    description: 'Add your 2D/3D files',
                },
                {
                    step: 2,
                    title: 'Configure Parts',
                    description: 'Set materials, finishes, and specifications for each part',
                },
                {
                    step: 3,
                    title: 'Quote/Buy',
                    description: 'Review pricing and submit your order or get a quote request',
                },
            ].map(item => (
                <div key={item.step} className="flex items-start gap-4 p-4 border border-slate-200 rounded-lg bg-white">
                    {/* Step number */}
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-slate-200 text-slate-700 flex items-center justify-center font-semibold">
                        {item.step}
                    </div>

                    {/* Text */}
                    <div>
                        <h4 className="font-semibold text-slate-800 text-sm mb-1">{item.title}</h4>
                        <p className="text-slate-600 text-sm leading-relaxed">{item.description}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};
